var render, staticRenderFns
import script from "./rfp-menu.dir.vue?vue&type=script&lang=js&"
export * from "./rfp-menu.dir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f9da7",
  null
  
)

export default component.exports